import _ from 'lodash'
import moment from 'moment'
import { isEmpty, MONTHS_OF, plural } from '@/helpers'

const MONTHS = [
  'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
  'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь',
]

const SIZE_UNITS = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']

export const MAX_TERM = 120

const number = (value, digits = 0) => new Intl.NumberFormat('ru-RU', { maximumFractionDigits: digits }).format(value)

export const toSizeString = bytes => {
  let value = bytes || 0
  let unit = 0

  while (value >= 1024 && unit < SIZE_UNITS.length - 1) {
    value /= 1024
    unit += 1
  }

  return `${number(value, unit > 0 && value < 100 ? 1 : 0)} ${SIZE_UNITS[unit]}`
}

export const toRowsString = rows => number(rows || 0)

export const toRowsCountString = rows => `${number(rows || 0)} ${plural(rows || 0, ['запись', 'записи', 'записей'])}`

export const toApproxRowsString = rows => {
  const count = rows || 0

  if (count >= 1000000) return `≈ ${number(count / 1000000, 1)} млн записей`
  if (count >= 1000) return `≈ ${number(count / 1000, count < 10000 ? 1 : 0)} тыс. записей`

  return `≈ ${toRowsCountString(count)}`
}

const toMonthString = value => {
  const date = moment(value)

  return `${MONTHS[date.month()]} ${date.year()}`
}

export const toDayString = value => {
  if (isEmpty(value)) return ''

  const date = moment(value)

  return `${date.date()} ${MONTHS_OF[date.month()]} ${date.year()}`
}

export const toTerm = value => (isEmpty(value) ? null : Number(value))

export const isTermValid = term => term === null || (Number.isInteger(term) && term >= 1 && term <= MAX_TERM)

export const termText = term => (term === null ? 'бессрочно' : `${term} ${plural(term, ['месяц', 'месяца', 'месяцев'])}`)

export const termField = key => _.lowerFirst(key)

const isFutureEmpty = (section, currentMonth) => section.kind === 'Month'
  && !section.rows
  && moment(section.from).isAfter(currentMonth)

const isListed = (section, currentMonth) => section.kind !== 'Default' && !isFutureEmpty(section, currentMonth)

const newestFirst = sections => _.orderBy(sections, [section => section.kind === 'Month', 'from'], ['desc', 'desc'])

export const sectionPeriod = section => {
  if (section.kind === 'History') return 'до разбиения по месяцам'

  return section.kind === 'Month' && section.from ? toMonthString(section.from) : section.name
}

export const listedSections = (sections, currentMonth) => newestFirst(
  sections.filter(section => isListed(section, currentMonth)),
)

export const sectionsToRemove = sections => newestFirst(sections.filter(section => section.willBeRemoved))

export const straySection = sections => sections.find(section => section.kind === 'Default' && section.rows > 0)

export const isRemovable = (section, term, currentMonth) => {
  if (term === null) return false

  const cutoff = moment(currentMonth).subtract(term, 'months')

  if (section.kind === 'Month') return moment(section.to).isSameOrBefore(cutoff)

  return section.kind === 'History' && !isEmpty(section.newestAt) && moment(section.newestAt).isBefore(cutoff)
}

export const sizeOf = sections => _.sumBy(sections, 'sizeBytes')
